import React from "react";
import { Dropdown } from "../../../common/components/dropdown/Dropdown";
import View from "../../views/View";

interface ViewSelectorProps {
	views: { key: number; value: string }[];
	loading: boolean;
	current?: typeof View;
	handleBindToView: (id) => void;
}

export function ViewSelector({
	views,
	loading,
	current,
	handleBindToView,
}: ViewSelectorProps) {
	const defaultView = current?.name || views[0].value;
	const dropdownToggle = !loading ? defaultView : "Loading...";

	return (
		<Dropdown
			dropdownToggle={dropdownToggle}
			dropdownItems={views}
			preselected={true}
			onDropdownItemClick={(id) => handleBindToView(id)}
			dropdownKey="view_selector"
		/>
	);
}
